import httpRequest from '@/services/httpRequest.js'

export default ({
  namespaced: true,
  state: {
    ready: false,
  },
  actions: {
    async getSchedules({ rootState }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectschedule`,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status === 200) {
        return resp.data.results
      }
      return []
    },
    async getHolidays({ rootState }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectschedule/weekday_holiday`,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status === 200) {
        return resp.data
      }
      return []
    },
    async getStudentExaminations({ rootState }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination`,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status === 200) {
        return resp.data.results;
      }
      return []
    },
  }
})